module.exports = __webpack_public_path__ + "img/1.19fc76ce.jpg";